import { render, staticRenderFns } from "./MaterialMultiCheckbox.vue?vue&type=template&id=45539470&scoped=true&"
import script from "./MaterialMultiCheckbox.vue?vue&type=script&lang=js&"
export * from "./MaterialMultiCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MaterialMultiCheckbox.vue?vue&type=style&index=0&id=45539470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45539470",
  null
  
)

export default component.exports